import { RouteStep } from '../types';

interface GetNextAccessibleStep {
  accessibleSteps: any[];
  currentStep: any;
  steps: RouteStep[];
}

function getNextAccessibleStep({ steps, accessibleSteps, currentStep }: GetNextAccessibleStep) {
  const currentStepIndex = steps.indexOf(currentStep);

  return accessibleSteps.find((step) => steps.indexOf(step) > currentStepIndex);
}

export default getNextAccessibleStep;
